import React, { useContext } from 'react';
import { Route, Redirect } from "react-router-dom";
import { AppContext, AppContextType } from '../../App';
import { RouteProps } from 'react-router';
import { LocationState } from '../Pages/LoginForm/useLoginForm';
import { useLocation } from 'react-router-dom';

export type ControlledRouteProps = {
    isAuthorized: boolean;
    redirectTarget?: string;
} & RouteProps;

export function PrivateRoute ( { ...routeProps}: ControlledRouteProps ) {
    const { isLoggedIn, currentUser }: AppContextType = useContext(AppContext);
    let location = useLocation<LocationState>();
    if (isLoggedIn) {
        return <Route {...routeProps} />;
    }else {
        return <Redirect to={{ pathname: routeProps.redirectTarget ? routeProps.redirectTarget :'/login',
            state: {from: location}
    }} />;  
    }
};

export function PublicRoute ( { ...routeProps}: ControlledRouteProps ) {
    return <Route {...routeProps} />;  
};